import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./css/header.css";
import { AccountCircle } from "./AccountCircle";
import { CurrentMetadataForUser } from "../context/CurrentMetadataForUser";
import { useLocation, useHistory } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import { TrialEndBanner } from "./payments/TrialEndBanner";

function Header({ showTrialEndBanner = true }) {
    const { isOnboardingCompleted } = useContext(CurrentMetadataForUser);
    const location = useLocation();
    const history = useHistory();
    const auth = getAuth();
    const [user] = useAuthState(auth);
    const [isTrialBannerVisible, setIsTrialBannerVisible] = useState(showTrialEndBanner);

    const handleNewFlowClick = () => {
        history.push("/take-a-flow");
    }

    return (
        <header className="header">
            {isOnboardingCompleted && (
                <div style={{ display: "flex" }}>
                    {location.pathname === '/flows' || (location.pathname === '/shared' && user)
                        ? <div style={{ height: "fit-content", marginRight: "1rem" }}>
                            <button className="header-btn" onClick={handleNewFlowClick}>
                                <span>➕ Flow</span>
                            </button>
                        </div>
                        : <div className="header-item-container" style={{ marginRight: "1rem" }}>
                            <Link className="header-item" to="/">
                                Normili
                            </Link>
                        </div>
                    }
                    <div className="header-item-container">
                        <Link className="header-item" to="/flows">
                            My Flows
                        </Link>
                    </div>
                </div>
            )}
            <div className="header-right">
                {isTrialBannerVisible && <TrialEndBanner onClose={() => setIsTrialBannerVisible(false)} />}
                <AccountCircle />
            </div>
        </header>
    );
}

export default Header;
